import { render, staticRenderFns } from "./ListFilters.vue?vue&type=template&id=080b7295"
import script from "./ListFilters.vue?vue&type=script&lang=js"
export * from "./ListFilters.vue?vue&type=script&lang=js"
import style0 from "./ListFilters.vue?vue&type=style&index=0&id=080b7295&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports